import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Chart } from "react-google-charts";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mobile: { minWidth: "1200px", height: "450px" },
    desktop: { minWidth: "100%" },
  })
);

export const data = [
  ["Year", "Sales", "Expenses"],
  ["2013", 1000, 400],
  ["2014", 1170, 460],
  ["2015", 660, 1120],
  ["2016", 1030, 540],
];

export default function ChartArea(props: chartAreaProps) {
  const styleGraphics = useStyles();
  const options = {
    title: props.title,
    hAxis: { title: props.descripcionH },
    vAxis: { title: props.descripcionV },
    //chartArea: { width: "50%", height: "70%" },
  };

  return (
    <div
      className={
        window.screen.width < 1000
          ? styleGraphics.mobile
          : styleGraphics.desktop
      }
    >
      <Chart
        chartType="AreaChart"
        width="100%"
        height="400px"
        data={props.data}
        options={options}
      />
    </div>
  );
}

interface chartAreaProps {
  data: Array<any>;
  title: string;
  descripcionH: string;
  descripcionV: string;
  getImage(img: any): void;
}
